import { ReactElement } from 'react';

import { useIntl } from 'react-intl';
import { formatTranslation } from 'intl';
import { ReportTranslationKeys } from 'intl/keys';
import {
  useCreateSingleInspectionReport,
  withCreateSingleInspectionReport,
} from 'components/dataCreationForms/report/withCreateSingleInspectionReport';
import { ButtonTextIcon } from 'components/general';
import { PictureAsPdf } from '@mui/icons-material';

function _InspectionPdfButton(): ReactElement {
  const intl = useIntl();
  const TEXT = formatTranslation(intl, ReportTranslationKeys.buttonPrintLabel);

  const { openDialog } = useCreateSingleInspectionReport();

  return (
    <ButtonTextIcon
      startIcon={PictureAsPdf}
      aria-label='Generate pdf'
      onClick={openDialog}
    >
      {TEXT}
    </ButtonTextIcon>
  );
}

export const InspectionPdfButton = withCreateSingleInspectionReport(
  _InspectionPdfButton
);
